var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{ref:"RtnPartMstTable",attrs:{"paging":"","index":"","pageUnit":_vm.pagingInfo.pageUnit,"totalSize":_vm.pagingInfo.totalSize,"columns":_vm.cmpnMstCols,"rows":_vm.rows,"excel":_vm.isButton_(_vm.scrId, 'EX'),"stripe":false,"selection":false,"creatable":""},on:{"changedPage":_vm.changedPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }